import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import { ColorfullBarChart } from "../../Common/Charts/ColorfullBarChart";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class ValueDescAndBarChartComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      component,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      layoutProps: { direction, minWidth }
    } = this.props;

    const {
      componentId,
      labels,
      data: { account, data },
      config: { description, annexeAttachmentCategory }
    } = component;

    const {
      percentage,
      code,
      currentValue,
      diffValue,
      unit,
      notAvailable
    } = account[0];

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={percentage}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.ValueDescAndBarChartComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
          style={minWidth ? { minWidth: "80%" } : null}
        >
          {!this.props.inSlideView && (
            <ComponentActions
              removeComponent={this.props.handleRemoveComponent}
              updateComponent={this.props.handleUpdateComponent}
              componentCase={this.props.ComponentCase}
              sideBar={"ComponentConfig"}
              component={"ValueDescAndBarChartComponent.png"}
            />
          )}
          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <div
              className={classnames(
                direction === "VERTICAL" ? "small-12" : "medium-5 small-5",
                styles.flex_container,
                styles.align_container
              )}
              style={direction ? { marginBottom: 25, marginTop: -20 } : null}
            >
              <span
                className={classnames("medium-12 small-12", styles.main_value)}
              >
                {notAvailable
                  ? currentValue
                  : number_format(currentValue, 2, ",", " ")}{" "}
                {unit !== "none" ? unit : ""}
              </span>
              <span
                className={classnames(
                  "medium-12 small-12",
                  styles.sub_value,
                  percentage > 0 ? styles.positive_value : styles.negative_value
                )}
              >
                {notAvailable
                  ? _("notAvailable")
                  : percentage !== null
                    ? percentage > 0
                      ? _("increaseOf")
                      : _("decreaseOf")
                    : ""}{" "}
                {percentage ? (
                  <span className={styles.positive_value}>
                    {notAvailable ? "" : number_format(diffValue, 2, ",", " ")}{" "}
                    {unit !== "none" ? unit : ""}
                  </span>
                ) : (
                  ""
                )}
                {/*{isOneYearDashboard ? "" : <br />}*/}
                {/*{lastYear ? (*/}
                {/*  <span className={styles.year_info}>*/}
                {/*    de <b>{lastYear}</b> à <b>{currentYear}</b>*/}
                {/*  </span>*/}
                {/*) : currentYear ? (*/}
                {/*  <span className={styles.year_info}>*/}
                {/*    à l'année <b>{currentYear}</b>*/}
                {/*  </span>*/}
                {/*) : (*/}
                {/*  ""*/}
                {/*)}*/}
              </span>
              <span
                className={classnames("medium-12 small-12", styles.description)}
              >
                {description}
              </span>
            </div>
            <span
              className={classnames(
                direction === "VERTICAL" ? "small-10" : "medium-7 small-7",
                styles.flex_container,
                styles.align_container
              )}
            >
              <ColorfullBarChart
                containerHeight={180}
                chartData={data}
                dataKeyY={code}
                dataKeyX={"year"}
                currency={unit === "€"}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default ValueDescAndBarChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ValueDescAndBarChartComponent.js